import * as styles from './index.css';
import { useNavConfig } from './use-nav-config';

export const DesktopNavbar = () => {
  const config = useNavConfig();

  return (
    <div className={styles.topNavLinks}>
      {config.map(item => {
        const isInternal = item.path.startsWith('/');
        return (
          <a
            key={item.title}
            href={item.path}
            target={isInternal ? undefined : '_blank'}
            rel={isInternal ? undefined : 'noreferrer'}
            className={styles.topNavLink}
          >
            {item.title}
          </a>
        );
      })}
    </div>
  );
};
